import type { AiCostDocumentsPayload } from '@Application/AiCosts/Actions/aiCostSummaryFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * Generated documents: `unpricedCount` counts the documents whose cost is incomplete because at least
 * one call has no price.
 */
class AiCostDocumentsView {
	readonly count: number;
	readonly costAmount: number;
	readonly unpricedCount: number;

	constructor(payload: AiCostDocumentsPayload) {
		this.count = payload.count;
		this.costAmount = payload.cost;
		this.unpricedCount = payload.unpricedCount;

		Object.freeze(this);
	}

	/** Average over the priced documents only; `null` when none is priced. */
	get averageCost(): number | null {
		const pricedCount = this.count - this.unpricedCount;

		return pricedCount > 0 ? this.costAmount / pricedCount : null;
	}
}

export default AiCostDocumentsView;
